
import { Student } from './student';
import {LearningOutcome} from './learning-outcome';

export interface AssignmentStudent {
  student: Student;
  scores: {
    learningOutcome: LearningOutcome;
    points?: 0 | 1 | 2 | 3 | 4;
  }[]
}

export class Assignment {
  requestKey: string;
  name: string;
  dateAdded: string;
  createdBy: string;
  learningOutcomes: LearningOutcome[];
  students: AssignmentStudent[];
  constructor(
  ) {
    this.requestKey = '';
    this.name = '';
    this.dateAdded = new Date().toISOString();
    this.createdBy = '';
    this.learningOutcomes = [];
    this.students = [];

  }

  public setAssignment(assignment: {
    requestKey: string;
    name: string;
    dateAdded: string;
    createdBy: string;
    learningOutcomes: LearningOutcome[];
    students: AssignmentStudent[];
  }) {
    this.requestKey = assignment.requestKey;
    this.name = assignment.name;
    this.dateAdded = assignment.dateAdded;
    this.createdBy = assignment.createdBy;
    this.learningOutcomes = [...assignment.learningOutcomes];
    this.students = [...assignment.students];
  }

  public updateStudentScore(studentRequestKey: string, learningOutcomeRequestKey: string, points: 0| 1 | 2 | 3 | 4): void {
    const student = this.students.find(s => s.student.requestKey === studentRequestKey);
    if (student) {
      const score = student.scores.find(s => s.learningOutcome.requestKey === learningOutcomeRequestKey);
      if (score) {
        score.points = points;
      }
      else {
        student.scores.push({
          learningOutcome: this.learningOutcomes.find(lo => lo.requestKey === learningOutcomeRequestKey) || new LearningOutcome(),
          points: points
        });
      }
    }
  }

  calculateStudentAverageScore(studentRequestKey: string): number {
    const student = this.students.find(s => s.student.requestKey === studentRequestKey);
    if (student && student.scores.length > 0) {
      const totalPoints = student.scores.reduce((sum, score) => sum + (score.points || 0), 0);
      return totalPoints / this.learningOutcomes.length;
    }
    return 0;
  }
  calculateAverageScorePercentage(studentRequestKey: string): number {
    const student = this.students.find(s => s.student.requestKey === studentRequestKey);
    if (student && student.scores.length > 0) {
      const totalPoints = student.scores.reduce((sum, score) => sum + (score.points || 0), 0);
      return ((totalPoints / this.learningOutcomes.length) * 100) / 4;
    }
    return 0;
  }

  public clear(): void {
    this.requestKey = '';
    this.name = '';
    this.dateAdded = "";
    this.createdBy = '';
    this.learningOutcomes = [];
    this.students = [];
  }
}
